.noDealsInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 55vh;
}

.icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--ib-chip);
  display: grid;
  place-items: center;
  font-size: 24px;
  margin-bottom: 14px;
}

.title {
  font-family: var(--font-serif);
  font-weight: 700;
  font-size: 18px;
  color: var(--ib-ink);
}

.desc {
  margin: 6px 0 0 0;
  color: var(--ib-muted);
  font-size: 13.5px;
  max-width: 360px;
  line-height: 1.5;
}
